import { authApi } from "@config/axios/axios.config";
import { API_ROUTES } from "@constants/api.routes";

/**
 * Generic service to fetch attachment URL by key
 * @param key - The attachment key from the API response
 * @returns Promise<string> - The attachment URL directly
 */
export const fetchAttachmentByKey = async (key: string): Promise<string> => {
	try {
		const response = await authApi.get<string>(API_ROUTES.ATTACHMENT_BY_KEY(key));
		return response.data;
	} catch (error) {
		console.error(`Error fetching attachment for key ${key}:`, error);
		throw error;
	}
};
